import React from 'react'
import { SectionWithTitle } from 'components/SectionWithTitle/SectionWithTitle'
import styled from 'styled-components'
import { ILocalFavourite } from 'types/location'
import { LocalFavouriteItem } from 'components/LocalFavourites/LocalFavouriteItem'
import { breakpointUpTo } from 'utils/breakpoints'

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.space[4]};
  justify-content: center;

  ${({ theme }) => breakpointUpTo(theme.breakpoints.md)} {
    gap: 20px;
  }
`
export type LocalFavouritesProps = {
  items: ILocalFavourite[]
  title: string
}
export const LocalFavourites = ({ items, title }: LocalFavouritesProps) => (
  <SectionWithTitle title={title}>
    <Wrapper>
      {items.map(({ id, ...rest }) => (
        <LocalFavouriteItem key={id} {...rest} />
      ))}
    </Wrapper>
  </SectionWithTitle>
)
